import { createContext, type RefObject, useContext } from "react";
import type { ViewMode } from "./visuals";
export interface PlanEditorContextValue {
  selectedId: string | null;
  select: (id: string) => void;
  configSlot: HTMLDivElement | null;
  shownStepId: string | null;
  itemRefs: RefObject<Map<string, HTMLDivElement>>;
  move: (id: string, action: () => void) => void;
  view: ViewMode;
  setMode: (mode: ViewMode) => void;
  hasSelection: boolean;
}
export const PlanEditorContext = createContext<PlanEditorContextValue | null>(null);
export const StepPosition = createContext({ index: 0, count: 0 });
export function usePlanEditor() {
  const value = useContext(PlanEditorContext);
  if (!value) throw new Error("usePlanEditor requires PlanEditor.Root");
  return value;
}
